import { DEFAULT_REGION, splitRegion } from "@/lib/region"
import { joinPrefix } from "@/lib/url-prefix"

const NON_PAGE_PATH = /^\/(?:api|_next|auth|images|videos|loading|\.?well-known|favicon\.ico|sitemap\.xml|robots\.txt)(?:\/|$)/

export const storefrontNavigationPath = (path: string, isApp: boolean): string => {
  if (!isApp || !path.startsWith("/") || path.startsWith("//")) return path
  const boundary = path.search(/[?#]/)
  const pathname = boundary < 0 ? path : path.slice(0, boundary)
  const suffix = boundary < 0 ? "" : path.slice(boundary)
  const { prefix, region, rest } = splitRegion(pathname)
  if (region !== DEFAULT_REGION || NON_PAGE_PATH.test(rest)) return path
  return `${joinPrefix(`${prefix}/${DEFAULT_REGION}`, rest)}${suffix}`
}

export const storefrontNavigationUrl = (href: string, currentUrl: string, isApp: boolean): URL => {
  const current = new URL(currentUrl)
  const target = new URL(href, current)
  if (target.origin === current.origin) target.pathname = storefrontNavigationPath(target.pathname, isApp)
  return target
}

export const storefrontNavigationHref = (href: string, isApp: boolean, origin?: string): string => {
  if (href.startsWith("/")) return storefrontNavigationPath(href, isApp)
  if (!isApp || !origin) return href
  try {
    const target = new URL(href)
    if (target.origin !== origin) return href
    target.pathname = storefrontNavigationPath(target.pathname, true)
    return target.href
  } catch {
    return href
  }
}
